import type { CycleState, CycleUnavailableActions } from "./reviewCycleSchemas.ts";

export function resolveUnavailableActions(state: CycleState): CycleUnavailableActions {
    if (state === "draft") {
        return { lock: "notLaunched" };
    }

    if (state === "locked") {
        return { edit: "locked" };
    }

    return {};
}
